/* @flow */
import UsersInvite from './UsersInvite';

export default UsersInvite;
